import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Add Assignment
export const addAssignmentsAPI = async (data) => {
  try {
    const response = await apiService.post(endpoints.addAssignments, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Assignment
export const updateAssignmentsAPI = async ({ id, data }) => {
  try {
    const response = await apiService.put(`${endpoints.updateAssignments}/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Archive Assignment (New)
// Method: PATCH, URL: /assignment/archive/{id}
export const archiveAssignmentsAPI = async ({ id, is_archive }) => {
  try {
    const response = await apiService.patch(`${endpoints.archiveAssignments}/${id}`, {
      is_archive: is_archive
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Assignment List (Updated with 'archived' param)
export const getAssignmentsListAPI = async ({ 
  page = 1, 
  limit = 10, 
  search = "", 
  access_group_id = [],
  archived // New parameter
} = {}) => {
  console.log('API called with params:', { page, limit, search, access_group_id, archived }); 
  
  try {
    const params = { page, limit, search };
    
    // Handle Access Groups
    if (access_group_id && access_group_id.length > 0) {
      params.access_group_id = access_group_id.join(',');
    }

    // Handle Archived status
    if (archived !== undefined && archived !== null) {
      params.archived = archived;
    }
    
    const response = await apiService.get(endpoints.getAssignmentsList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Assignment Detail
export const getAssignmentsDetailAPI = async (id) => {
  try {
    const response = await apiService.get(`${endpoints.getAssignmentsDetail}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Delete Assignment
export const deleteAssignmentsAPI = async (id) => {
  try {
    const response = await apiService.delete(`${endpoints.deleteAssignments}/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};